import { useMemo } from 'react';
import moment from 'moment';
import Text from 'components/design-system/Text/Text';

export const ColumnsTableLogs = () => {
  const columnTablesLogs = useMemo(
    //quiero crear un codigo que calcule el rut
    () => [
      {
        header: 'Código',
        enableGlobalFilter: false,
        accessorKey: 'codigoRegistroActividad',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: false,
        enableColumnFilter: false
      },
      {
        header: 'Negocio',
        accessorKey: 'nombreEmpresa',
        Cell: ({ renderedCellValue }) => (
          <Text>{renderedCellValue ? renderedCellValue : '-'}</Text>
        )
        // enableColumnActions: false,
        // enableColumnFilter: false
      },
      {
        header: 'Sucursal',
        accessorKey: 'nombreSucursal',
        Cell: ({ renderedCellValue }) => (
          <Text>{renderedCellValue ? renderedCellValue : '-'}</Text>
        )
      },
      {
        header: 'Correo usuario',
        enableGlobalFilter: false,
        accessorKey: 'correoElectronico',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: false,
        enableColumnFilter: false
      },
      {
        header: 'Acción',
        accessorKey: 'descripcionAccion',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>
      },
      {
        header: 'Descripción',
        enableGlobalFilter: false,
        accessorKey: 'descripcion',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        enableColumnActions: false,
        enableColumnFilter: false
      },
      {
        header: 'Fecha/hora registro',
        enableGlobalFilter: false,
        accessorKey: 'fechaHora',
        Cell: ({ renderedCellValue }) => (
          <Text>
            {moment
              .utc(renderedCellValue)
              .local()
              .format('DD-MM-YYYY HH:mm:ss')}
          </Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false
      }
    ],
    []
  );
  return columnTablesLogs;
};
